<template>
    <div class="wrapper">
        <div class="main">
            <page-header/>
            <div class="section">
                <div class="container">
                    <div class="col-md-5 mx-auto">
                        <form @submit.prevent="login" autocomplete="off">
                            <card type="login" plain>
                                <div slot="header" class="logo-container">
                                    <h2>登入</h2>
                                </div>
                                <fg-input class="no-border input-lg"
                                          addon-left-icon="now-ui-icons users_circle-08"
                                          placeholder="手機"
                                          autocomplete="off"
                                          v-model="form.account"
                                >
                                </fg-input>
                                <fg-input class="no-border input-lg"
                                          type="password"
                                          addon-left-icon="now-ui-icons ui-1_lock-circle-open"
                                          placeholder="密碼"
                                          autocomplete="off"
                                          v-model="form.password"
                                >
                                </fg-input>
                                <template slot="raw-content">
                                    <div class="card-footer text-center">
                                        <button type="submit" class="btn btn-outline-info btn-round btn-block">登入
                                        </button>
                                    </div>
                                    <div class="pull-left">
                                        <h6>
                                            還沒有帳戶?
                                            <router-link :to="{name: 'Register'}" class="ml-2 link footer-link">註冊</router-link>
                                        </h6>
                                    </div>
                                    <div class="pull-right">
                                        <h6>
                                            <router-link :to="{name: 'ForgotPassword'}" class="link footer-link">忘記密碼</router-link>
                                        </h6>
                                    </div>
                                </template>
                            </card>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Card, Button, FormGroupInput} from '@/components';
    import PageHeader from "@/views/partials/PageHeader";
    import {AuthService} from "@/services/rest/auth";
    import {createNamespacedHelpers} from 'vuex';
    const {mapMutations} = createNamespacedHelpers('Auth');
    import {alertError} from '@/helper/alert_helper';

    export default {
        name: "LoginPage",
        components: {
            PageHeader,
            Card,
            [Button.name]: Button,
            [FormGroupInput.name]: FormGroupInput
        },
        data() {
            return {
                form: {
                    account: '',
                    password: ''
                }
            }
        },
        methods: {
            ...mapMutations(['toggleLogin']),
            async login() {
                try {
                    const {data} = await new AuthService().login(this.form);

                    localStorage.setItem("token", data.token);

                    this.toggleLogin();

                    this.$router.push('Home');
                } catch (err) {
                    alertError(err);
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .card-login {
        border-radius: 0.25rem;
        padding-bottom: 0.7rem;
        max-width: 320px;
    }

    .section {
        text-align: center;
    }
</style>
